import React, { useEffect, useState, useCallback } from "react";
import ListReportsRedeSus from "./list";
import {
  Spinner,
  Pagination,
  Row,
  Col,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Table,
  Button,
  Form,
  PaginationItem,
  PaginationLink,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import { Suport, ButtonOrder, ButtonDownload } from "./styles";
import api from "../../services/client/api";
import cookie from "../../services/cookie/index";
import { deleteCookies } from "../../utils/functions";
import { validateDates } from "../../utils/validations";
import { useHistory, useLocation } from "react-router-dom";
import {
  faMicroscope,
  faSort,
  faBroom,
  faSearch,
  faDownload,
  faCalendarWeek,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ReportsRedeSusView() {
  useEffect(() => {
    document.title = "CEDAP | Projeto Jornada do Paciente";
  }, []);
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => setModalOpen(!modalOpen);
  const [groupedReports, setGroupedReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const qtdPerPage = 5; // exames por página
  let [, setQtdPages] = useState(0);
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState("desc");
  const [reports, setReports] = useState([]);
  let [search, setSearch] = useState("");
  let [usersFound, setUsersFound] = useState([]);
  const [isReportsNull, setReportsNull] = useState(false);
  const [isFilteredByDate, setIsFilteredByDate] = useState(false);
  const [fields, setFields] = useState({ dateStart: "", dateEnd: "" });
  const today = new Date();
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {}, [usersFound]);

  useEffect(() => {
    if (search !== "") {
      let usersSearching = reports.filter(
        (report) =>
          report.NomPaciente?.toLowerCase().includes(
            search.toLowerCase(),
          ) /*  ||
          maskCPF(user.cpf).includes(search) ||
          user.cpf.includes(search) ||
          ns(user.email).includes(search) */,
      );

      setUsersFound(usersSearching);
      setQtdPages(Math.round(usersSearching.length / 15));
      setPage(1);
      return;
    }

    setPage(1);
    setQtdPages(Math.round(reports.length / 15));
    setUsersFound(reports);
  }, [search, setUsersFound, reports]);

  const formatDateBR = (date) => {
    if (!date) return "";

    // se vier como string YYYY-MM-DD
    if (typeof date === "string") {
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }

    // se já for Date (ex: today)
    return date.toLocaleDateString("pt-BR");
  };
  let startDate;
  let endDate;

  if (isFilteredByDate) {
    startDate = fields.dateStart;
    endDate = fields.dateEnd;
  } else {
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    startDate = firstDay;
    endDate = today;
  }

  const groupedByPatient = Object.values(
    usersFound.reduce((acc, report) => {
      if (!acc[report.MatConvenio]) {
        acc[report.MatConvenio] = [];
      }
      acc[report.MatConvenio].push(report);
      return acc;
    }, {}),
  )
    .map((group) =>
      group.sort((a, b) => {
        const dateA = new Date(a.DtaSolicitacao);
        const dateB = new Date(b.DtaSolicitacao);
        return order === "desc" ? dateB - dateA : dateA - dateB;
      }),
    )
    .sort((a, b) => {
      const dateA = new Date(a[0].DtaSolicitacao);
      const dateB = new Date(b[0].DtaSolicitacao);
      return order === "desc" ? dateB - dateA : dateA - dateB;
    });

  const qtdPages = Math.ceil(groupedByPatient.length / qtdPerPage);
  // Pega somente os meses da página atual
  const paginatedReports = groupedByPatient.slice(
    qtdPerPage * (page - 1),
    qtdPerPage * page,
  );
  const history = useHistory();
  const location = useLocation();
  const token = cookie().get("tokenDoc");
  const username = cookie().get("username");
  const getReportsByDate = useCallback(async () => {
    const validationError = validateDates(fields.dateStart, fields.dateEnd);
    setReportsNull(false);
    if (validationError) {
      alert(validationError);
      return;
    }

    setIsLoading(true);

    try {
      const response = await api()
        .user()
        .getAllRedeSusByDate(token, username, fields.dateStart, fields.dateEnd);
      if (response.status === 401) {
        await deleteCookies();
        return history.replace({ pathname: "/login" });
      }

      if (response.status === 200) {
        if (response.output === null) {
          setReportsNull(true);
          setIsLoading(false); // muito importante

          return;
        }
        setReports(response.output);
        setPage(1); // resetar paginação ao filtrar
        setIsFilteredByDate(true);
        setIsLoading(false);
      } else if (response.status === 404) {
        setErrorMessage("error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erro ao obter arquivos:", error);
      setErrorMessage("Erro ao carregar arquivos.");
      setIsLoading(false);
    }
  }, [fields, history, token]);
  /* outras partes do codigo */
  const getReports = useCallback(async () => {
    setReportsNull(false);
    try {
      const response = await api().user().getAllRedeSus(token, username);

      if (response.status === 401) {
        await deleteCookies();
        history.replace({ pathname: "/login" });
        return;
      }

      if (response.status === 200) {
        setIsFilteredByDate(false);
        setReports(response.output);
        setIsLoading(false);
      } else if (response.status === 404) {
        setReportsNull(true);
        setIsLoading(false); // muito importante
      } else if (response.status === 400) {
        setErrorMessage("error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erro ao obter arquivos:", error);
      setErrorMessage("Erro ao carregar arquivos.");
      setIsLoading(false);
    }
  }, [history, token]);

  useEffect(() => {
    if (username) {
      getReports();
    }

    if (location.state?.successMessage) {
      alert(location.state.successMessage);
      history.replace({ pathname: location.pathname, state: {} });
    }
  }, [username, location, history, getReports]);

  const refreshReports = () => {
    setReportsNull(false); // resetar alerta
    if (isFilteredByDate) {
      getReportsByDate();
    } else {
      getReports();
    }
  };

  const downloadExcel = async () => {
    setDownloading(true);

    try {
      let dataInicio;
      let dataFinal;

      if (isFilteredByDate) {
        dataInicio = fields.dateStart;
        dataFinal = fields.dateEnd;
      } else {
        const today = new Date();

        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

        // formatar para YYYY-MM-DD (ou o formato que sua API espera)
        const formatDate = (date) => date.toISOString().split("T")[0];

        dataInicio = formatDate(firstDay);
        dataFinal = formatDate(today);
      }

      const response = await api()
        .file()
        .downloadRedeSus(token, dataInicio, dataFinal, reports);

      if (response.status === 401) {
        await deleteCookies();
        history.replace({ pathname: "/doctor" });
        return;
      }

      if (response.status === 200) {
        const blob = new Blob([response.output], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = `${dataInicio}_${dataFinal}.xlsx`;

        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Erro ao baixar Excel:", error);
    }

    setDownloading(false);
  };

  const PaginationComponent = () => {
    let elements = [];

    for (let i = page - 3; i < page; i++) {
      if (i > 0) {
        elements.push(
          <PaginationItem key={i} active={i === page}>
            <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
          </PaginationItem>,
        );
      }
    }

    for (let i = page - 1; i < qtdPages && i < page + 3; i++) {
      const thisPage = i + 1;
      elements.push(
        <PaginationItem key={thisPage} active={thisPage === page}>
          <PaginationLink onClick={() => setPage(thisPage)}>
            {thisPage}
          </PaginationLink>
        </PaginationItem>,
      );
    }

    return (
      <Pagination>
        <PaginationItem>
          <PaginationLink
            first
            onClick={() => setPage(1)}
            disabled={page === 1}
          />
        </PaginationItem>

        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => setPage(page - 1)} />
        </PaginationItem>

        {elements}

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink next onClick={() => setPage(page + 1)} />
        </PaginationItem>

        <PaginationItem disabled={page === qtdPages}>
          <PaginationLink last onClick={() => setPage(qtdPages)} />
        </PaginationItem>
      </Pagination>
    );
  };

  return (
    <div>
      {!errorMessage && (
        <h1>
          <FontAwesomeIcon icon={faMicroscope} /> Relatório de Exames
        </h1>
      )}

      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Selecione o intervalo de datas
        </ModalHeader>

        <ModalBody>
          <Row>
            <Col md={6}>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Data Início</InputGroupText>
                  </InputGroupAddon>

                  <Input
                    type="date"
                    value={fields.dateStart}
                    onChange={(e) =>
                      setFields({ ...fields, dateStart: e.target.value })
                    }
                  />
                </InputGroup>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>Data Fim</InputGroupText>
                  </InputGroupAddon>

                  <Input
                    type="date"
                    value={fields.dateEnd}
                    onChange={(e) =>
                      setFields({ ...fields, dateEnd: e.target.value })
                    }
                  />
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              toggleModal(); // fecha o modal
              getReportsByDate(); // executa busca
            }}
          >
            <b>Buscar</b> <FontAwesomeIcon icon={faSearch} />
          </Button>
        </ModalFooter>
      </Modal>

      {isLoading ? (
        <div>
          <Spinner color="primary" /> Carregando...
        </div>
      ) : errorMessage ? (
        <Alert color="danger">
          Erro ao encontrar exames, atualize a página e tente novamente. Caso o
          problema persista, entre em contato com a equipe de suporte!
        </Alert>
      ) : (
        <>
          {groupedReports.length === 0}

          <>
            {paginatedReports.length === 0}

            <ButtonOrder color="secondary" onClick={toggleModal}>
              Selecionar datas <FontAwesomeIcon icon={faCalendarWeek} />
            </ButtonOrder>
            <ButtonDownload
              color="success"
              disabled={downloading}
              onClick={downloadExcel}
            >
              {downloading ? (
                <>
                  <Spinner size="sm" /> Gerando...
                </>
              ) : (
                <>
                  Gerar Planilha <FontAwesomeIcon icon={faDownload} />
                </>
              )}
            </ButtonDownload>

            <br />
            <span
              style={{ color: "#43494e", fontSize: "15px", marginTop: "10px" }}
            >
              Apresentando exames entre as datas{" "}
              <b>{formatDateBR(startDate)}</b> até{" "}
              <b>{formatDateBR(endDate)}</b>
            </span>
            <Form>
              <Row
                style={{
                  display: "flex",
                  alignItems: "stretch",
                  marginTop: "10px",
                }}
              >
                <Col md={6}>
                  <FormGroup style={{ height: "100%", marginBottom: 0 }}>
                    <InputGroup style={{ height: "100%" }}>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>Buscar Paciente</InputGroupText>
                      </InputGroupAddon>

                      <Input
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                        required
                        type="text"
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                <Col
                  md={6}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    color="light"
                    style={{
                      height: "38px", // altura padrão do input
                    }}
                    onClick={() => window.location.reload()}
                  >
                    <b>Limpar filtros</b> <FontAwesomeIcon icon={faBroom} />
                  </Button>
                </Col>
              </Row>
            </Form>

            {isReportsNull ? (
              <Alert color="warning">
                Nenhum exame encontrado nas datas selecionadas.
              </Alert>
            ) : (
              <Table striped bordered responsive style={{ marginTop: "10px" }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}> </th>
                    <th style={{ textAlign: "center" }}>Cod Exame</th>
                    <th style={{ textAlign: "center" }}>Nome Paciente</th>
                    <th
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                      onClick={() =>
                        setOrder(order === "desc" ? "asc" : "desc")
                      }
                    >
                      Data Final{" "}
                      <FontAwesomeIcon
                        icon={order === "desc" ? faSort : faSort}
                        style={{
                          marginLeft: 3,
                          fontSize: "1.0rem",
                          opacity: 0.7,
                        }}
                      />
                    </th>
                    <th style={{ textAlign: "center" }}>Diagnostico</th>
                    <th style={{ textAlign: "center" }}>Topografia</th>
                    <th style={{ textAlign: "center" }}>Nome exame</th>
                    <th style={{ textAlign: "center" }}>Matricula</th>
                    <th style={{ textAlign: "center" }}>Cartão SUS</th>
                    <th style={{ textAlign: "center" }}>CNES</th>
                    {/*      <th style={{ textAlign: "center" }}>CID10</th> */}
                    <th style={{ textAlign: "center" }}>Estabelecimento</th>
                    <th style={{ textAlign: "center" }}>Situação</th>
                    <th style={{ textAlign: "center" }}>Laudo</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedReports.map((patientReports, index) => (
                    <ListReportsRedeSus
                      key={index}
                      reports={patientReports}
                      token={token}
                      username={username}
                      refreshReports={refreshReports}
                    />
                  ))}
                </tbody>
              </Table>
            )}
            {qtdPages > 1 && <PaginationComponent />}
            <span style={{ color: "#43494e", fontSize: "15px" }}>
              Exames retornados:{" "}
              <u>
                <b>{reports.length}</b>
              </u>
            </span>
            <Suport href="https://wa.me/5547991865855" target="_blank">
              <u>Suporte</u>
              <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
            </Suport>
          </>
        </>
      )}
    </div>
  );
}
